import React, { useRef, createRef, useEffect } from "react";
import { CategoryButton, HorizontalMenuItem, Wrapper } from "./styles";

const HorizontalMenu = ({ data, scrollTo, selected }) => {
  const menuRef = useRef(null);
  const sectionRefs = useRef({});

  const normalizedData = data.map((item) => {
    sectionRefs.current[data.id] = createRef();

    return item;
  });

  useEffect(() => {
    sectionRefs.current[selected].scrollIntoView({ inline: "center" });
  }, [selected]);

  return (   
      <Wrapper id="horizontal" ref={(el) => (menuRef.current = el)}>
        {normalizedData.map((item) => {
          return (
            <HorizontalMenuItem
              key={item.value}
              ref={(el) => (sectionRefs.current[item.value] = el)}
            >
              <CategoryButton
                type="button"
                active={selected === item.value}
                onClick={() => scrollTo(item.value)}
              >
                {item.label}
              </CategoryButton>
            </HorizontalMenuItem>
          );
        })}
      </Wrapper>
  );
};

export default HorizontalMenu;
